import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIButton from 'UIComponents/button/UIButton';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage'; // @ts-expect-error Untyped import

import ContentControlWrapper from '../../../components/ContentControlWrapper'; // @ts-expect-error Untyped import

import ContentViewport from '../../../components/ContentViewport';
const BASE_CLASS_NAME = 'exam-access-issue-screen';

const ExamAccessIssueScreen = () => /*#__PURE__*/_jsxs("div", {
  className: BASE_CLASS_NAME,
  children: [/*#__PURE__*/_jsx(ContentViewport, {
    paddingClassName: `${BASE_CLASS_NAME}__content`,
    children: /*#__PURE__*/_jsxs(UIErrorMessage, {
      illustration: "keys",
      illustrationProps: {
        width: 200
      },
      title: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.requiredScopeError.heading"
        })
      }),
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.requiredScopeError.body"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.requiredScopeError.explainer"
        })
      })]
    })
  }), /*#__PURE__*/_jsx(ContentControlWrapper, {
    className: `${BASE_CLASS_NAME}__content-control`,
    children: /*#__PURE__*/_jsx(UIButton, {
      disabled: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.exams.examQuestion.nextButton"
      })
    })
  })]
});

export default ExamAccessIssueScreen;